import axios from 'axios';
import config from './office365-config';

class LocalAuthService {
    constructor() {
        this.apiUrl = '/products-homepage/api/login';
        this.ssoConfig = config.sso;
    }

    login(email, password) {
        return axios.post(this.apiUrl, {
            email: email,
            password: password
        }).then(response => {
            const data = response.data;
            const userToken = data.token || data.accessToken || data.access_token;

            if (userToken) {
                this.saveToken(userToken);
                return userToken;
            }
            throw new Error('Authentication failed');
        });
    }

    saveToken(token) {
        const expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + 8);
        document.cookie = `${this.ssoConfig.cookieName}=${token}; expires=${expirationDate.toUTCString()}; path=/;`;
    }
}

export default new LocalAuthService();
